import { apiCall } from '../../services/apiUtil';

/**
 * Reporting reads. Every call takes the same filter object, so a filter set on
 * one section means the same thing on the next.
 */
const qs = (params = {}) => {
  const p = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== '' && v != null),
  ).toString();
  return p ? `?${p}` : '';
};

export const reportsAPI = {
  /** Revenue, enrolments and occupancy across programmes and open play. */
  overview:   (params) => apiCall(`/reports/overview${qs(params)}`),
  /** Owed, forgone and invisible money, ranked, each with what moves it. */
  leakage:    (params) => apiCall(`/reports/leakage${qs(params)}`),
  /** Fill rate and revenue by day of week and hour. */
  demand:     (params) => apiCall(`/reports/demand${qs(params)}`),
  /** Expected revenue from scheduled sessions, carrying its own basis. */
  projection: (params) => apiCall(`/reports/projection${qs(params)}`),
};
